import React from 'react';

import type { PageComponent } from '../../pages.types';

export const Error500Page: PageComponent = (): React.ReactElement => {
  return (
    <div data-testid='error500' className='text-center'>
      <h1 className='display-1 font-weight-bold'>500</h1>
      <p className='h1'>Внутренняя ошибка сервера.</p>
      <p className='h2 font-weight-normal mt-3 mb-4'>
        Сервер столкнулся с чем-то неожиданным, что не позволило ему завершить
        запрос.
      </p>
    </div>
  );
};
